<style lang="less" scoped>
.van-checkbox--checked {
  color: #fff;
  border-color: #ff9000 !important;
  background-color: #ff9000 !important;
}
.cart {
  .cart-section {
    .card-goods {
      background-color: #fff;
      position: relative;
      &__item {
        position: relative;
        padding: 10px 0 10px 2%;
        border-bottom: 1px solid #e5e5e5;

        .van-checkbox__input {
          top: 50%;
          left: 15px;
          margin-top: -10px;
          position: absolute;
        }
        .van-checkbox__label {
          margin: 0;
          width: 100%;
          padding-left: 35px;
          box-sizing: border-box;
          .van-card {
            background: #fff;
            .van-card__thumb {
              width: 1.68rem !important;
              height: 1.68rem !important;
              background-color: #f00;
              margin-left: -0.15rem;
              .van-card__img {
                display: none;
              }
            }
          }
        }
        .van-card__price {
          color: #f44;
        }
      }

      .steper {
        position: absolute;
        top: 0;
        right: 4%;
        li {
          height: 100px;
          padding-bottom: 20px;
          display: flex;
          align-items: flex-end;
        }
      }
    }
    .van-submit-bar {
      .van-checkbox {
        font-size: 0.26rem;
        padding-left: 0.15rem;
      }
    }
  }
  .cart-empty {
    text-align: center;
    .cart-tip {
      padding: 0 0.3rem;
      height: 0.8rem;
      line-height: 0.8rem;
      background: rgb(253, 251, 238);

      span {
        display: block;
        float: left;

        &:nth-child(1) {
          width: 0.3rem;
          height: 0.8rem;
          margin-right: 0.1rem;
          background: url("../../../static/image/goods/splitPic/addCart/ios/notice.png")
            no-repeat center center;
        }
        &:nth-child(2) {
          color: rgb(255, 144, 0);
          font-size: 0.22rem;
        }
        &:nth-child(3) {
          float: right;
          width: 0.3rem;
          height: 0.8rem;
          background: url("../../../static/image/goods/splitPic/addCart/ios/back.png")
            no-repeat center center;
        }
      }
    }

    .cart-ico {
      padding: 0.42rem 2.62rem 0.6rem;
      .cart-icon-p {
        display: block;
        width: 2.28rem;
        height: 2.28rem;
        background: url("../../../static/image/goods/splitPic/addCart/ios/cart.png")
          no-repeat center center;
      }
    }
    .empty-warm {
      font-size: 0.3rem;
      margin-top: 0.3rem;
      margin-bottom: 0.02rem;
      color: rgb(51, 51, 51);
    }
    .pick-some {
      font-size: 0.24rem;
      color: rgb(123, 123, 123);
      margin-bottom: 0.74rem;
    }
    .van-button--small {
      font-size: 0.34rem;
      color: #fff;
      background-color: rgb(255, 144, 0);
      width: 4.56rem;
      height: 0.8rem;
      line-height: 0.8rem;
      border-radius: 0.2rem;
    }
  }
  .van-card {
    padding: 5px 10px !important;

    .van-card__content {
      width: 200px !important;
    }
  }
  .van-nav-bar .van-icon {
    font-weight: bold;
    color: #000;
    vertical-align: middle;
  }
  .van-nav-bar {
    height: 0.8rem;
    line-height: 0.8rem;

    .van-nav-bar__title {
      font-size: 0.34rem;
      color: rgb(51, 51, 51);
      font-weight: bold;
      border-bottom: 1px solid #efe8e8;
    }
    .van-nav-bar__right {
      right: 0.25rem;
      .van-nav-bar__text {
        color: rgb(51, 51, 51);
        margin: 0 -15px;
        padding: 0 15px;
        display: inline-block;
        vertical-align: middle;
      }
      .van-nav-more {
        display: inline-block;
        width: 0.34rem;
        height: 0.8rem;
        margin-left: 0.03rem;
        background: url("../../../static/image/goods/splitPic/addCart/ios/more.png")
          no-repeat center bottom;
      }
    }
  }

  .goods-count {
    height: 0.8rem;
    padding: 0 0.3rem;
    line-height: 0.8rem;
    font-size: 0.22rem;
    color: rgb(94, 94, 94);
  }
  .submitBar {
    position: fixed;
  }
  .bookmap {
    position: absolute;
    top: 0;
    right: 110px;
    background-color: #f44;
    color: #fff;
    outline: none;
    border: none;
  }
}
</style>

<template>
  <div class="cart">
    <!-- <div data-v-4a5ab35b=""
         class="van-nav-bar van-hairline--top-bottom"
         style="z-index: 1;">
      <div class="van-nav-bar__left"
           @click='onClickLeft'><i class="van-icon van-nav-bar__arrow van-icon-arrow">
        </i>

      </div>
      <div class="van-nav-bar__title">购物车</div>
      <div class="van-nav-bar__right"
           v-if='hasGood==1'>
        <span class="van-nav-bar__text"
              @click="editCard(0)"
              v-if='isEdit ==0'>编辑</span>
        <span class="van-nav-bar__text"
              v-else
              @click="editCard(1)">完成</span>
      </div>
    </div> -->

    <div class="cart-section"
         v-if="goods!=0">
      <div class='goods-count'>
        共{{goods.length}}件商品
      </div>
      <van-checkbox-group class="card-goods"
                          v-model="checkedGoods">
        <van-checkbox class="card-goods__item"
                      v-for="item in goods"
                      :key="item.kid"
                      :name="item.kid">
          <van-card :title="item.name"
                    :num='item.count'
                    :desc="item.color+'-'+item.size"
                    :price="parseInt(item.price)"
                    :thumb="item.goodsDetail.src" />
        </van-checkbox>

      </van-checkbox-group>
      <van-submit-bar v-if='isEdit == 0'
                      :price="totalPrice"
                      :disabled="!checkedGoods.length"
                      :button-text="submitBarText"
                      @submit="onSubmit">
        <div class=""
             @click="checkall">
          <van-checkbox v-model="allChecked">全选</van-checkbox>
        </div>
      </van-submit-bar>
      <van-submit-bar v-else
                      class='submitBar'
                      button-text="删除"
                      @submit="toDelete">
        <div class=""
             @click="checkall">
          <van-checkbox v-model="allChecked">全选</van-checkbox>
        </div>
        <van-button type="warning"
                    class='bookmap'
                    @click='toMarkBook'>移入收藏夹</van-button>
      </van-submit-bar>

    </div>
    <!--购物车为空-->
    <div class="cart-empty"
         v-else>
      <van-notice-bar text="自营商品订单金额满88元可免邮费"
                      left-icon="volume-o"
                      mode="link" />
      <div class="cart-ico">
        <i class="cart-icon-p"></i>
      </div>
      <p class="empty-warm">购物车空空如也哦~</p>
      <p class='pick-some'>去挑选几件喜欢的商品吧</p>
      <router-link to="/home">
        <van-button size="small">随便逛逛</van-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { debug, debuglog } from 'util';
import { Dialog } from 'vant';
import { constants } from 'fs';
import { Toast } from 'vant';
//import {eventBus} from '../../assets/js/eventBus'

//import { Checkbox, CheckboxGroup, Card, SubmitBar } from 'vant';
export default {

  store,
  data () {
    return {
      isEdit: 0,//是否编辑状态
      checkedGoods: [],
      goods: [],
      allChecked: false,
      flag: true,
      hasGood: 0,//是否有收藏货物 0无不显示
    };
  },
  watch: {
    //监听单选框，选择状态
    checkedGoods (e, old) {
      console.log(e)
      if (this.goods.length == e.length) {
        this.allChecked = true
      }
      else {
        this.allChecked = false
      }
    }
  },
  mounted () {
    //  debugger
    this.goods = this.selectGoods
    if (this.goods.length == 0) {
      this.hasGood = 0;

      if (this.AndroisIos() == true) {
        window.android.changeRightText(3);
        return;

      } else {
        //IOS
        window.webkit.messageHandlers.changeRightText.postMessage(3);
        return;

      }
    } else {
      this.hasGood = 1;
    }
    console.log(this.selectGoods);
    window['editCart'] = (a) => {
      this.editCard(a);
    }
  },
  computed: {
    submitBarText () {
      const count = this.checkedGoods.length;
      return '结算' + (count ? `(${count})` : '');
    },
    totalPrice () {
      //有出现则累加，没有则为0
      return this.goods.reduce((total, item) => total + (this.checkedGoods.indexOf(item.kid) !== -1 ? parseInt(item.price * 100) * item.count : 0), 0);
    },
    ...mapState({
      selectGoods: state => state.selectGoods//绑定store.selectGoods到组件，之后可用this.selectGoods获取
    })
  },
  methods: {
    //全选返选
    checkall () {
      // //debugger
      let arr = []
      if (this.allChecked) {
        this.selectGoods.forEach((item, index) => {
          arr.push(this.selectGoods[index].kid)
        });
        this.checkedGoods = arr
      } else {
        this.checkedGoods = []
      }
    },
    //返回上一页
    onClickLeft () {
      this.$router.go(-1);
    },
    //跳到结算页
    onSubmit () {
      debugger
      let payGoods = [],
        noChosenGoods = [];
      this.selectGoods.forEach((item, index) => {
        var selectGoodsIndex = index;
        for (var i = 0; i < this.checkedGoods.length; i++) {
          if (this.checkedGoods[i] == this.selectGoods[index].kid) {
            payGoods.push(this.selectGoods[index]);
            //删除提交支付的，留下不选中的
            this.selectGoods.splice(selectGoodsIndex, 1);
            console.log('相同')
          }
        }
      });
      this.$store.state.cartGoodstoPay = payGoods;
      console.log('sdjfs888qweqw21412329083128399238');
      console.log(payGoods);

      //统合
      this.$store.state.commonGood = [];
      this.$store.state.commonGood = payGoods;

      this.$router.push({ name: '/pay', params: { isDetailOrCart: 1 } }); //1：购物车
    },
    //编辑功能，全选，加入收藏夹或者删除
    editCard (a) {
      if (a == 1) {
        //完成
        //  Toast('接受到' + window.android.changeRightText(1));
        (this.isEdit == 0) ? (this.isEdit = 1) : (this.isEdit = 0);
        if (this.AndroisIos() == true) {
          //android
          window.android.changeRightText(0);
          return;
        } else {
          //IOS
          window.webkit.messageHandlers.changeRightText.postMessage(0);
          return;
        }

      } else {
        //编辑
        //  Toast('接受到' + window.android.changeRightText(0));
        (this.isEdit == 0) ? (this.isEdit = 1) : (this.isEdit = 0);

        if (this.AndroisIos() == true) {
          //android
          window.android.changeRightText(1);
          return;

        } else {
          //IOS
          window.webkit.messageHandlers.changeRightText.postMessage(1);
          return;

        }
      }
    },
    //删除购物车
    toDelete () {
      //弹出框
      Dialog.alert({
        message: '确定删除选中的商品'
      }).then(() => {
        this.selectGoods.forEach((item, index) => {
          var selectGoodsIndex = index;
          debugger

          for (var i = 0; i < this.checkedGoods.length; i++) {
            if (this.checkedGoods[i] == this.selectGoods[index].kid) {
              //删除提交支付的，留下不选中的
              this.selectGoods.splice(selectGoodsIndex, 1);
            }
          }
        });

        if (this.selectGoods.length == 0) {
          this.hasGood = 0;
          if (this.AndroisIos() == true) {
            window.android.changeRightText(3);
            return;
          } else {
            //IOS
            window.webkit.messageHandlers.changeRightText.postMessage(3);
            return;

          }
        } else {
          //删除购物车、加入收藏夹都要触发changeRightText
          if (this.AndroisIos() == true) {
            window.android.changeRightText(0);
            return;

          } else {
            //IOS
            window.webkit.messageHandlers.changeRightText.postMessage(0);
            return;

          }
        }
      });
    },
    //加入收藏夹
    toMarkBook () {
      var addBookGood = [];
      this.selectGoods.forEach((item, index) => {
        debugger
        var selectGoodsIndex = index,
          selectGoodsItem = item;

        for (var i = 0; i < this.checkedGoods.length; i++) {
          if (this.checkedGoods[i] == this.selectGoods[index].kid) {
            //删除提交支付的，留下不选中的
            this.$store.state.bookMark.push(selectGoodsItem);
            this.selectGoods.splice(selectGoodsIndex, 1);
            console.log(this.$store.state.bookMark);
          }
        }
      });

      console.log(this.$store.state.bookMark)
      // this.$store.state.bookMark = this.unique(this.$store.state.bookMark);
      console.log(this.$store.state.bookMark)

      Toast({
        message: '加入收藏夹成功'
      });
      this.isEdit = 0;

      if (this.selectGoods.length == 0) {
        this.hasGood = 0;
        if (this.AndroisIos() == true) {
          window.android.changeRightText(3);
          return;
        } else {
          //IOS
          window.webkit.messageHandlers.changeRightText.postMessage(3);
          return;

        }
      } else {
        //删除购物车、加入收藏夹都要触发changeRightText
        if (this.AndroisIos() == true) {
          window.android.changeRightText(0);
          return;

        } else {
          //IOS
          window.webkit.messageHandlers.changeRightText.postMessage(0);
          return;

        }
      }
    },
    //去除重复
    unique (arr) {
      let hashTable = {};
      let newArr = [];
      for (let i = 0, l = arr.length; i < l; i++) {
        if (!hashTable[arr[i].kid]) {
          hashTable[arr[i].kid] = true;
          newArr.push(arr[i]);
        }
      }
      return newArr;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/cart/cart.vue